module.exports = __webpack_public_path__ + "a1d1501d48cb3b11627b6cf49d863145.svg";